$(document).ready(function(){
  var today = new Date();
  var dd = today.getDate();
  var mm = today.getMonth()+1; //January is 0!
  var yyyy = today.getFullYear();
  if(dd<10) {
    dd = '0'+dd;
  } 
  if(mm<10) {
    mm = '0'+mm;
  } 
  today = mm + '/' + dd + '/' + yyyy;
  var currentDate = new Date(today);
  var options = { month: 'numeric' };
  var todayDate = { day: 'numeric' };
  var crdate =  currentDate.toLocaleDateString('en-US', todayDate);
  var currentMonth =  currentDate.toLocaleDateString('en-US', options);
  $('#calendar').click(function(){
    $('#ContactForm-date').trigger('focus')
  });

  var rushShippingStart = 21;
  var rushShippingStartNum = Number(21);
  var rushShippingEnd = 23;
  var rushShippingEndNum = Number(23);
  var rushObject = [];
  var rushShippingDateStart = 24;
  var rushShippingDateStartNum = Number(24);
  var rushShippingDateEnd = 25;
  var rushShippingDateEndNum = Number(25);
  var rushPriceObject = [];
  var rushDisableDateStart = 1;
  var rushDisableDateEnd = 15;
  var rushDisabelDateObject = [];
  // Rush 150
  var rushShipping150DateStart = 16;
  var rushShipping150DateStartNum = Number(16);
  var rushShipping150DateEnd = 20;
  var rushShipping150DateEndNum = Number(20);
  var rushPriceObject = [];


  for(var i=rushDisableDateStart;i<=rushDisableDateEnd; i++){
    var tempDisabelDate = new Date(); 
    tempDisabelDate.setDate(currentDate.getDate() + i); 
    rushDisabelDateObject[tempDisabelDate.getDate()] = "0";
  }
  for(var i=rushShippingStart;i<=rushShippingEnd; i++){
    var tempRushDate = new Date(); 
    tempRushDate.setDate(currentDate.getDate() + i); 
    rushObject[tempRushDate.getDate()] = "$150";
  }

  // Rush 150
  for(var i=rushShipping150DateStart;i<=rushShipping150DateEnd; i++){
    var tempRushDate150 = new Date();
    tempRushDate150.setDate(currentDate.getDate() + i);
    rushObject[tempRushDate150.getDate()] = "$200";
  }
  
  for(var i=rushShippingDateStart;i<=rushShippingDateEnd; i++){
    var tempRushPriceDate = new Date(); 
    tempRushPriceDate.setDate(currentDate.getDate() + i);     
    rushPriceObject[tempRushPriceDate.getDate()] = "$100";
    var options = { month: 'numeric' };
    var lastDate = { day: 'numeric' };
    var tempRushPricecustomDate =  tempRushPriceDate.toLocaleDateString('en-US', options);
    var lsdate =  tempRushPriceDate.toLocaleDateString('en-US', lastDate);
  }

  function updateDatePickerCells(dp) {
    /* Wait until current callstack is finished so the datepicker
       is fully rendered before attempting to modify contents */
    setTimeout(function () {
      if((Number(currentMonth) <= Number(tempRushPricecustomDate)) || (Number(currentMonth) == 12)){
        var crmonget = currentMonth - 1;
        var lsmonget = tempRushPricecustomDate - 1;
        var cellContents = rushObject;
        var cellPriceContents = rushPriceObject;
        var cellDisabelDateContents = rushDisabelDateObject;
        $('.ui-datepicker td').each(function (idx, elem) {
          var getdate = $(this).find('a').text();
          if(getdate != undefined || getdate != ''){
            $(this).attr('data-date',getdate)
          }
        });
        //Select disabled days (span) for proper indexing but // apply the rule only to enabled days(a)
        $('.ui-datepicker td > *').each(function (idx, elem) {
          var datamonth = $(this).closest('td').attr('data-month');
          if(datamonth == crmonget || datamonth == lsmonget){
            var datadate = $(this).closest('td').attr('data-date');
            if(Number(datadate) <= Number(lsdate) || datamonth == crmonget){
              var value = cellContents[idx + 1];
              var shipping_value = cellPriceContents[idx + 1];
              var disabel_date = cellDisabelDateContents[idx + 1];
              if(value !== undefined){
                $(this).attr("shipping_price", value);
                $(this).parents('td').addClass('shipping-price');
              }
              if(shipping_value !== undefined){
                $(this).attr("shipping_price", shipping_value);
                $(this).parents('td').addClass('shipping-price-update');
              }
              if(disabel_date !== undefined){
                $(this).get(0).tagName = "span"; 
                $(this).parents('td').addClass('shipping-disable-date');
              }
            }
            
          }
        }); 
      }
      //Fill this with the data you want to insert (I use and AJAX request).  Key is day of month
      //NOTE* watch out for CSS special characters in the value
      
    }, 0);
  }
  updateDatePickerCells();

  // Click to open datepicker
  $("#ContactForm-date").datepicker({
      dateFormat:'mm/dd/yy',
      minDate: 0,
      maxDate: "+2M +0D",
      orientation: "top",
      beforeShow: function(elem, dp,input, inst) { //This is for non-inline datepicker
        updateDatePickerCells();
        $(this).change();
      },
      onSelect: function (date, dp) {
        updateDatePickerCells();
        $(this).change();
      },
      onChangeMonthYear: function(month, year, dp) {
        updateDatePickerCells();
      }
  });

  let val = sessionStorage.getItem('date')
  var cartnotevalue = sessionStorage.getItem('Cart Note');
  // var cartnotevalue = sessionStorage.getItem('Cart Note');
  const numberOfYears = 3;
  const currentYear = new Date().getFullYear();
  const yearsArray = [];
  for (let i = 0; i < numberOfYears; i++) {
    yearsArray.push(currentYear + i);
  }
    
  function arrayValueExistsInString(array, string) {
    for (let i = 0; i < array?.length; i++) {
      if (string?.includes(array[i])) {
        return array[i];
      }
    }
    return false;
  }
  const existsInString = arrayValueExistsInString(yearsArray, cartnotevalue);
  let noteValueUpdate = '';
  if (existsInString != null) {    
    noteValueUpdate = cartnotevalue?.split(existsInString);
    if(noteValueUpdate != NaN && noteValueUpdate != undefined && noteValueUpdate != null){
    noteValueUpdate = noteValueUpdate[noteValueUpdate?.length - 1];
    }
  } 

  var d = new Date(val);
  var options = { year: 'numeric', month: 'short', day: 'numeric' };
  var customDate =  d.toLocaleDateString('en-US', options);
  var newCartNoteVal = 'Event Date: '+customDate+'';
  var cartfff = ''
  if(noteValueUpdate !== null && noteValueUpdate !== undefined){
    cartfff = newCartNoteVal + ' ' + noteValueUpdate;  
  }else{
   cartfff = newCartNoteVal; 
  }
  
  if(val){
    if(cartnotevalue !== null && cartnotevalue !== undefined){       
      setTimeout (function(){
        if(localStorage.getItem('EventDate') == '1') {
          $('#cart-note,.cart__footer textarea').val('No Event Date');
        }else if (localStorage.getItem('EventDate') == '0'){
          $('#ContactForm-date').val(val)
          var cartNotVal = cartfff;  
          $('#cart_note').val(cartfff);
        }else{
          $('#ContactForm-date').val(val)
          var cartNotVal = cartfff;  
          $('#cart_note').val(cartfff);
        }
      
      }, 700)
      var params = {
        type: 'POST',
        url: '/cart/update.js',
        data: 'note=' + cartfff,
        dataType: 'json',
        success: function(cart) {
          console.log(cart)
        },
        error: function(XMLHttpRequest, textStatus) {
  
        }
      };
      jQuery.ajax(params);
      sessionStorage.setItem('Cart Note',cartfff);
     
    }else{
      var d = new Date(val);
      var options = { year: 'numeric', month: 'short', day: 'numeric' };
      var customDate =  d.toLocaleDateString('en-US', options);    
      setTimeout (function(){
        $('#ContactForm-date').val(val)
        $('#cart_note').val('Event Date: '+customDate+'');
      }, 700)
      var params = {
        type: 'POST',
        url: '/cart/update.js',
        data: 'note=' + 'Event Date: '+customDate+'',
        dataType: 'json',
        success: function(cart) {
          console.log(cart)
        },
        error: function(XMLHttpRequest, textStatus) {
  
        }
      };
      jQuery.ajax(params);
    }
  }

  // var cartnotevalue = sessionStorage.getItem('Cart Note');
  // const numberOfYears = 3;
  // const currentYear = new Date().getFullYear();
  // const yearsArray = [];
  // for (let i = 0; i < numberOfYears; i++) {
  //   yearsArray.push(currentYear + i);
  // }
    
  // function arrayValueExistsInString(array, string) {
  //   for (let i = 0; i < array.length; i++) {
  //     if (string.includes(array[i])) {
  //       return array[i];
  //     }
  //   }
  //   return false;
  // }
  // const existsInString = arrayValueExistsInString(yearsArray, cartnotevalue);
  // let noteValueUpdate = '';
  // if (existsInString != null) {    
  //   noteValueUpdate = cartnotevalue.split(existsInString);
  //   noteValueUpdate = noteValueUpdate[noteValueUpdate.length - 1];
  // } 

  // var d = new Date(val);
  // var options = { year: 'numeric', month: 'short', day: 'numeric' };
  // var customDate =  d.toLocaleDateString('en-US', options);
  // var newCartNoteVal = 'Event Date: '+customDate+'';
  // var cartfff = ''
  // if(noteValueUpdate !== null && noteValueUpdate !== undefined){
  //   cartfff = newCartNoteVal + ' ' + noteValueUpdate;  
  // }else{
  //  cartfff = addNoteVal; 
  // }
  console.log('cartfff',cartfff);
  
  
  $("#ContactForm-date").focus(function () {
    $('html, body').animate({ scrollTop: $(this).offset().top - 25 }, 10);
  });

  // $('#cart_note').keyup(function(){
  //   var noteValue = $(this).val();
  //   console.log("noteValue=====", noteValue)
  //   sessionStorage.setItem('Cart Note',noteValue);
  // });

  $('#cart_note').on("change",function(){
    var noteValue = $(this).val();
    // console.log("noteValue=====", noteValue)
    sessionStorage.setItem('Cart Note',noteValue);
    var cartnotevalue = sessionStorage.getItem('Cart Note');
    if(localStorage.getItem('EventDate') == '1') {
      $('#cart-note,.cart__footer textarea').val(cartnotevalue);
      var params = {
        type: 'POST',
        url: '/cart/update.js',
        data: 'note=' + cartnotevalue,
        dataType: 'json',
        success: function(cart) {
          console.log(cart)
        },
        error: function(XMLHttpRequest, textStatus) {

        }
      };
      jQuery.ajax(params);
    }
  });
      
  // ACTIONS
  $("#ContactForm-date").on("change", function(e) {
    var s_date = document.getElementById("ContactForm-date").value;    
    $(this).siblings(".label-error").text("");
    $(this).removeClass("error");
    today = new Date(today);
    s_date = new Date(s_date);
    var input_date = $(this).val();
    var d = new Date(input_date);
    var options = { year: 'numeric', month: 'short', day: 'numeric' };
    var customDate =  d.toLocaleDateString('en-US', options);
    var noteVal = $('#cart_note').val();
    
    sessionStorage.setItem('date',input_date); 
    // var val = sessionStorage.getItem('date');

    // if(val){
    //   var d = new Date(val);
    //   var options = { year: 'numeric', month: 'short', day: 'numeric' };
    //   var customDate =  d.toLocaleDateString('en-US', options);    
    //   setTimeout (function(){
    //     $(this).val(val);
    //     $('#cart_note').val('Event Date: '+customDate+'');
    //   }, 200)
    // }
    var milli_secs = s_date.getTime() - today.getTime();
    var days = milli_secs / (1000 * 3600 * 24);
    if(days >= rushShippingStartNum && days <= rushShippingEndNum ){
      $('#shipping_100').find('.date_input').attr('value' , input_date);
      var productProp = $('#item_rush-fee-150').find('.item-property.rush-fee span').text();      
      if(productProp == input_date){
         
      }else{
        $('#shipping_100 input[type="submit"]')[0].click();
        setTimeout (function(){
          var remove_link = $('#item_rush-fee-150').find('.CartItem__Remove').attr('href');
          var remove_link1 = $('#item_rush-fee-100').find('.CartItem__Remove').attr('href');
          var remove_link2 = $('#item_rush-fee-200').find('.CartItem__Remove').attr('href');
          $('.shipping_100').attr('href' , remove_link);
          $('.shipping_50').attr('href' , remove_link1);
          $('.shipping_150').attr('href' , remove_link2);
          if(remove_link1){
            setTimeout (function(){
              $('#item_rush-fee-100 .CartItem__Remove')[0].click();
            }, 250);
          }
          if(remove_link2){
            setTimeout (function(){
              $('#item_rush-fee-200 .CartItem__Remove')[0].click();
            }, 250);
          }
        }, 1400);
        $('#shipping_50').find('.date_input').val('');
        $('#shipping_150').find('.date_input').val('');
        $('.cart-drawer').addClass('add-fee');
        $('.fee-wrapper').show();
        $('.fee-wrapper').text('Rush Fee of '+ rushObject[tempRushDate.getDate()] +' applied');   
      }
    }

    // Rush 150 start
    if(days >= rushShipping150DateStartNum && days <= rushShipping150DateEndNum ){
      $('#shipping_150').find('.date_input').attr('value' , input_date);
      var productProp = $('#item_rush-fee-200').find('.item-property.rush-fee span').text();      
      if(productProp == input_date){
         
      }else{
        $('#shipping_150 input[type="submit"]')[0].click();
        setTimeout (function(){
          var remove_link3 = $('#item_rush-fee-200').find('.CartItem__Remove').attr('href');
          var remove_link4 = $('#item_rush-fee-100').find('.CartItem__Remove').attr('href');
          var remove_link5 = $('#item_rush-fee-150').find('.CartItem__Remove').attr('href');
          $('.shipping_150').attr('href' , remove_link3);
          $('.product_100').attr('href' , remove_link5);
          $('.shipping_50').attr('href' , remove_link4);
          if(remove_link4){
            setTimeout (function(){
              $('#item_rush-fee-100 .CartItem__Remove')[0].click();
            }, 250);
          }
          if(remove_link5){
            setTimeout (function(){
              $('#item_rush-fee-150 .CartItem__Remove')[0].click();
            }, 250);
          }
        }, 1400);
        $('#shipping_100').find('.date_input').val('');
        $('#shipping_50').find('.date_input').val('');
        $('.cart-drawer').addClass('add-fee');
        $('.fee-wrapper').show();
        $('.fee-wrapper').text('Rush Fee of '+ rushObject[tempRushDate150.getDate()] +' applied');
      }
    }
    // Rush 150 End

    if(days >= rushShippingDateStartNum && days <= rushShippingDateEndNum ){
      $('#shipping_50').find('.date_input').attr('value' , input_date);
      var productProp = $('#item_rush-fee-100').find('.item-property.rush-fee span').text();
      if(productProp == input_date){
         
      }else{
        $('#shipping_50 input[type="submit"]')[0].click();
        setTimeout (function(){
          var remove_link2 = $('#item_rush-fee-150').find('.CartItem__Remove').attr('href');
          var remove_link3 = $('#item_rush-fee-100').find('.CartItem__Remove').attr('href');
          var remove_link4 = $('#item_rush-fee-200').find('.CartItem__Remove').attr('href');
          $('.shipping_100').attr('href' , remove_link2);
          $('.shipping_50').attr('href' , remove_link3);
          $('.shipping_150').attr('href' , remove_link4);
          if(remove_link2){
            setTimeout (function(){
              $('.shipping_100')[0].click();
            }, 250);
          }
          if(remove_link4){
            console.log('first')
            setTimeout (function(){
              $('.shipping_150')[0].click();
            }, 250);
          }
        }, 1400);
        $('#shipping_100').find('.date_input').val('');
        $('#shipping_150').find('.date_input').val('');
        $('.cart-drawer').addClass('add-fee');
        $('.fee-wrapper').show();
        $('.fee-wrapper').text('Rush Fee of '+ rushPriceObject[tempRushPriceDate.getDate()] +' applied');
      }
    }
    if(days >=rushShipping150DateStartNum && days <= rushShippingDateEndNum){
      $('.cart__footer').addClass('show_checkout');
    }else{
      $('.cart__footer').removeClass('show_checkout');
      var remove_link4 = $('#item_rush-fee-150').find('.remove').attr('href');
      var remove_link5 = $('#item_rush-fee-100').find('.remove').attr('href');
      var remove_link6 = $('#item_rush-fee-200').find('.remove').attr('href');
      $('.shipping_100').attr('href' , remove_link4);
      $('.shipping_50').attr('href' , remove_link5);
      $('.shipping_150').attr('href' , remove_link6);
      if(remove_link4){
        setTimeout (function() {
          $('.shipping_100')[0].click();
        }, 1000);
      }
      if(remove_link5){
        setTimeout (function(){
          $('.shipping_50')[0].click();
        }, 1000);
      }
      if(remove_link6){
        setTimeout (function(){
          $('.shipping_150')[0].click();
        }, 1000);
      }
      if(customDate != 'Invalid Date' && noteVal == ''){
        $('#cart_note').val('Event Date: '+customDate+'');
        var params = {
          type: 'POST',
          url: '/cart/update.js',
          data: 'note=' + 'Event Date: '+customDate+'',
          dataType: 'json',
          success: function(cart) {
            console.log(cart)
          },
          error: function(XMLHttpRequest, textStatus) {

          }
        };
        jQuery.ajax(params);
      }else if(customDate != 'Invalid Date' && noteVal != ''){
        // $('#cart_note').val('');
        const customDateNew = sessionStorage.getItem('date');

        var d = new Date(customDateNew); 
        var options = { year: 'numeric', month: 'short', day: 'numeric' };
        var customNoteDateNew =  d.toLocaleDateString('en-US', options);            
        
        console.log('customNoteDateNew',customNoteDateNew);
        let noteValueUpdate = '';
        let lastStringYear = customNoteDateNew.split(",");
        lastStringYear = lastStringYear[lastStringYear.length - 1].trim();
        console.log("lastStringYear", lastStringYear)

        // Year Match start
        let matchYear = lastStringYear; 
        let nextYear = Number(matchYear) + 1;
        let prevYear = Number(matchYear) - 1;
        let nextYearString = nextYear.toString();
        let prevYearString = prevYear.toString();                  
        if(noteVal.includes(prevYearString)){
          // console.log('prevYear',prevYear)
          matchYear = prevYearString;
        }else if(noteVal.includes(nextYearString)){
          matchYear = nextYearString;
          // console.log('nextYear',nextYear)
        }else if(noteVal.includes(lastStringYear)){
          matchYear = lastStringYear;
        }
        // console.log("matchYear", matchYear)

        // Year Match end
        
        
        noteValueUpdate = noteVal.split(matchYear);
        
        noteValueUpdate = noteValueUpdate[noteValueUpdate.length - 1].trimStart();
        console.log("noteValueUpdate>>>>>>>>>>", noteValueUpdate)
        var addNoteVal = 'Event Date: ' + customDate + ' ' + noteValueUpdate;
        // var addNoteVal = 'Event Date: '+customDate+' +' '+ '+noteValueUpdate';
        console.log('addNoteVal',addNoteVal);
        $('#cart_note').val(addNoteVal);
        var params = {
          type: 'POST',
          url: '/cart/update.js',
          data: 'note=' + addNoteVal,
          dataType: 'json',
          success: function(cart) {
            console.log(cart)
          },
          error: function(XMLHttpRequest, textStatus) {

          }
        };
        jQuery.ajax(params);
        // sessionStorage.setItem('Cart Note',addNoteVal);
      }
      $('.cart-drawer').removeClass('add-fee');
      $(".fee-wrapper").text('');      
    }
  });

  $("#ContactForm-date").on("focusout", function(e) {
    if($(this).val() != '') {
      dateValidation($(this));
    }
  });

  // CHECK
  function dateValidation(input) {
    var errorLabel = input.siblings(".label-error");
    var date = input.val();
    input.removeClass("error");
    errorLabel.text("");
    var matches = /^(\d{1,2})[/\/](\d{1,2})[/\/](\d{4})$/.exec(date);
    if (matches == null) {
      input.addClass("error");
      errorLabel.text("Date not valid.");
    };
    var d = matches[1];
    var m = matches[2] - 1;
    var y = matches[3];
    var composedDate = new Date(y, m, d);
    if(composedDate.getDate() == d && composedDate.getMonth() == m && composedDate.getFullYear() == y) {} else {
      input.addClass("error");
      errorLabel.text("Date not valid.");
    }
  }
  var shippingLen = $('.shipping_product').length;
});

$(document).ready(function(){
  $('.event-date-checkbox input[type="checkbox"]').click(function(){
    if($(this).prop("checked") == true){
      $('#ContactForm-date').val('');
      var remove_link4 = $('#item_rush-fee-150').find('.remove').attr('href');
      var remove_link5 = $('#item_rush-fee-100').find('.remove').attr('href');
      $('.shipping_100').attr('href' , remove_link4);
      $('.shipping_50').attr('href' , remove_link5);
      $('.fee-wrapper').hide();
      $('.cart-drawer').removeClass('add-fee');
      if(remove_link4){
        setTimeout (function(){
          $('.shipping_100')[0].click();
        }, 1000);
      }    
      if(remove_link5){
        setTimeout (function(){
          $('.shipping_50')[0].click();
        }, 1000);
      }
    }else if($(this).prop("checked") == false){
      // $('.fee-wrapper').show();
    }
  });
});  